import React, { useState } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../components/SafeIcon';
import { FiCheckSquare, FiSquare, FiPlus, FiDownloadCloud } from 'react-icons/fi';
import { packingList as initialData } from '../data/mockData';

export default function PackingView() {
  const [list, setList] = useState(initialData);

  const toggleItem = (catIdx, itemIdx) => {
    const newList = [...list];
    newList[catIdx].items[itemIdx].checked = !newList[catIdx].items[itemIdx].checked;
    setList(newList);
  };

  const totalItems = list.reduce((acc, cat) => acc + cat.items.length, 0);
  const checkedItems = list.reduce((acc, cat) => acc + cat.items.filter(i => i.checked).length, 0);
  const progress = Math.round((checkedItems / totalItems) * 100) || 0;

  return (
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -20 }}>
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-end mb-8 gap-4">
        <div>
          <h2 className="text-2xl font-mono text-white mb-2">OFFLINE BOARD</h2>
          <p className="text-gray-400 text-sm">Sync items for offline access & packing.</p>
        </div>
        <button className="flex items-center gap-2 px-4 py-2 rounded-lg bg-white/5 border border-white/10 hover:bg-white/10 transition-colors text-sm font-mono text-gray-300">
          <SafeIcon icon={FiDownloadCloud} />
          SYNC OFFLINE
        </button>
      </div>

      {/* Progress Bar */}
      <div className="glass-card p-4 mb-8 flex items-center gap-4">
        <div className="w-12 h-12 rounded-full border-2 border-cyan-400/30 flex items-center justify-center font-mono text-cyan-400 text-sm">
          {progress}%
        </div>
        <div className="flex-1">
          <div className="flex justify-between text-xs font-mono text-gray-400 mb-2">
            <span>PACKING PROGRESS</span>
            <span>{checkedItems} / {totalItems} ITEMS</span>
          </div>
          <div className="w-full h-2 bg-black/40 rounded-full overflow-hidden">
            <motion.div 
              initial={{ width: 0 }} animate={{ width: `${progress}%` }} 
              className="h-full bg-cyan-400"
            />
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {list.map((category, catIdx) => (
          <div key={catIdx} className="glass-card p-6">
            <h3 className="font-mono text-sm text-cyan-400 mb-4 tracking-widest">{category.category.toUpperCase()}</h3>
            <div className="space-y-3">
              {category.items.map((item, itemIdx) => (
                <div 
                  key={itemIdx} 
                  onClick={() => toggleItem(catIdx, itemIdx)}
                  className={`flex items-center gap-3 p-3 rounded-lg border transition-all cursor-pointer ${
                    item.checked 
                      ? 'bg-cyan-400/5 border-cyan-400/20 text-gray-400' 
                      : 'bg-white/5 border-white/10 text-white hover:border-white/30'
                  }`}
                >
                  <SafeIcon 
                    icon={item.checked ? FiCheckSquare : FiSquare} 
                    className={`text-xl ${item.checked ? 'text-cyan-400' : 'text-gray-500'}`} 
                  />
                  <span className={`text-sm ${item.checked ? 'line-through opacity-50' : ''}`}>
                    {item.name}
                  </span>
                </div>
              ))}
              <button className="w-full flex items-center gap-2 p-3 text-sm text-gray-500 hover:text-cyan-400 transition-colors border border-transparent hover:border-dashed hover:border-cyan-400/30 rounded-lg rounded-xl mt-2">
                <SafeIcon icon={FiPlus} />
                <span>Add Item</span>
              </button>
            </div>
          </div>
        ))}
      </div>
    </motion.div>
  );
}